var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9057 2.86021C17.1259 3.30957 16.9474 3.85599 16.5071 4.08068C12.8118 5.96688 10.8378 7.80438 8.99759 11.1569C8.71048 11.68 8.71048 12.32 8.99759 12.8431C10.8378 16.1956 12.8118 18.0331 16.5071 19.9193C16.9474 20.144 17.1259 20.6904 16.9057 21.1399C16.6856 21.5891 16.1504 21.7713 15.7102 21.5466C11.736 19.5181 9.47842 17.441 7.44279 13.7325C6.8524 12.6569 6.8524 11.3431 7.44279 10.2675C9.47842 6.559 11.736 4.48185 15.7102 2.45338C16.1504 2.2287 16.6856 2.41084 16.9057 2.86021Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow-Left.033f3419.svg";
export { ForwardRef as ReactComponent };